<!-- 个人绑定审核 -->
<template>
    <div>
        <el-row type="flex" class="row-bg" justify="center">
            <el-col :span="15">
                <el-card class="box-card card">
                    <el-row class="title-box">
                        <el-col :span="24">
                            <div class="grid-content bg-purple-dark info-box">
                                <span class="title">高端人才{{ this.$route.query.text }}</span>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="grid-content bg-purple-dark">
                                <el-form :label-position="labelPosition" label-width="148px">
                                    <el-form-item label="姓名">
                                        <el-input v-model="deteilData.name" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="手机号">
                                        <el-input v-model="deteilData.phone" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="参加工作时间">
                                        <el-input v-model="deteilData.startWorkDate" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="邮箱">
                                        <el-input v-model="deteilData.email" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="现居住地">
                                        <el-input v-model="deteilData.dwell" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="性别">
                                        <el-input v-model="gender" readonly="readonly" class="inp text-bg define-inp">
                                        </el-input>
                                    </el-form-item>

                                    <el-form-item label="学历">
                                        <el-input v-model="deteilData.degreeCategory" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="年龄">
                                        <el-input v-model="deteilData.age" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="工作经验">
                                        <el-input v-model="deteilData.workYearDesc" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="工作经历" class="card_info">
                                        <!-- <el-input v-for="item in deteilData.expectList" v-model="item.industryDesc"
                                            readonly="readonly" class="inp text-bg define-inp"></el-input> -->
                                        <el-collapse accordion>
                                            <el-collapse-item :title="item.companyName"
                                                :name="index" v-for="(item, index) in deteilData.workExpList"
                                                :key="index">
                                                <div>公司名称：{{ item.companyName }}</div>
                                                <div>职位名称：{{ item.customPositionName }}</div>
                                                <div>所属部门：{{ item.department }}</div>
                                                <div>在职时间：{{ item.startDate }}-{{ item.endDate }}</div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </el-form-item>

                                    <el-form-item label="教育经历" class="card_info">
                                        <!-- <el-input v-for="item in deteilData.expectList" v-model="item.industryDesc"
                                            readonly="readonly" class="inp text-bg define-inp"></el-input> -->
                                        <el-collapse accordion>
                                            <el-collapse-item :title="item.schoolName"
                                                :name="index" v-for="(item, index) in deteilData.educationExpList"
                                                :key="index">
                                                <div>学校名称：{{ item.schoolName }}</div>
                                                <div>专业名称：{{ item.major }}</div>
                                                <div>学历水平：{{ item.degreeName }}</div>
                                                <div>在校时间：{{ item.startYear }}-{{ item.endYear }}</div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </el-form-item>

                                    <el-form-item label="求职意向" class="card_info">
                                        <!-- <el-input v-for="item in deteilData.expectList" v-model="item.industryDesc"
                                            readonly="readonly" class="inp text-bg define-inp"></el-input> -->
                                        <el-collapse accordion>
                                            <el-collapse-item :title="item.positionDesc" :name="index"
                                                v-for="(item, index) in deteilData.expectList" :key="index">
                                                <div>期望职位：{{ item.positionDesc }}</div>
                                                <div>期望行业：{{ item.industryDesc }}</div>
                                                <div>期望地点：{{ item.postArea }}-{{ item.postTown }}</div>
                                                <div>期望薪资：{{ item.lowSalary }}-{{ item.highSalary }}元</div>
                                            </el-collapse-item>
                                        </el-collapse>
                                    </el-form-item>

                                    <el-form-item label="我的优势">
                                        <el-input v-model="deteilData.userDesc" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>

                                    <el-form-item label="拒绝理由" v-if="this.$route.query.checkStatus == 2">
                                        <el-input v-model="this.$route.query.remark" readonly="readonly"
                                            class="inp text-bg define-inp"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row type="flex" justify="center" class="btn-list" v-if="this.$route.query.checkStatus == 0">
                        <el-col :span="13" style="text-align:center;">
                            <el-button type="primary theme-btn" class="btn pass"
                                @click.native="submitRemake(1, remark)">
                                通过</el-button>
                            <el-button class="btn refuse" @click.native="alertRemakeFn">拒绝</el-button>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>

        <!-- 审核理由对话框 -->
        <el-dialog :visible.sync="showRemake" width="30%">
            <div>
                <el-input type="textarea" class="checkText" :rows="10" placeholder="请输入拒绝理由" maxlength="99"
                    show-word-limit v-model="remark">
                </el-input>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showRemake = false">取 消</el-button>
                <el-button class="theme-btn" type="primary" @click.native="submitRemake(2, remark)">提 交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>

export default {
    data() {
        return {
            labelPosition: 'right',
            label: '统一社会信用代码\n或注册号',
            showRemake: false,
            deteilData: "",
            remark: '',  // 审核理由
            companyName: '', // 公司名称
            code: '',    // 统一社会信用代码或注册号
            businessLicense: '',  // 营业执照
            gender: "", // 性别
            ridlist: 0,
        }
    },
    props: ['item'],
    methods: {
        alertRemakeFn() {
            this.showRemake = true;
        },
        submitRemake(status, remark) {    // status 2 通过  3拒绝
            let id = this.ridlist
            let that = this
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
            this.axiosPost(`/userExpertApply/update`,
                {
                    id: id,
                    updateEmp: userInfo.id,
                    checkStatus: status,
                    remark: remark
                }
            ).then((res) => {
                let status = res.code == 200 ? 'success' : 'error'
                this.$message({
                    showClose: true,
                    message: res.message,
                    type: status,
                    duration: 1500
                });
                this.$router.go(-1)
                that.$emit('statusFun', true)
            })
        },
        findVoById() {
            let id = this.ridlist
            this.axiosGet(`/userExpertApply/findUserById/${id}`).then((res) => {
                this.deteilData = res.data
                if (this.deteilData.gender == 1) {
                    this.gender = '男'
                } else {
                    this.gender = '女'
                }
            })
        },
    },
    created() {
        this.remake = ''  // 审核理由
        this.ridlist = this.$route.query.id
        let id = this.$route.query.id
        this.axiosGet(`/userExpertApply/findById/${id}`).then((res) => {
            console.log(res)
            this.companyName = res.data.companyName
            this.code = res.data.registration
            this.businessLicense = res.data.businessLicense
            this.findVoById()
        })
    },
    components: {}
}
</script>
<style lang="less" scoped>
.inp {
    width: 80%;
    height: 40px;
    padding-left: 2%;
    border-radius: 4px;
}

.num {
    font-size: 48px;
    font-weight: 500;
    color: #197FFB;
    line-height: 74px;
    margin-right: 10px;
}

.info-box {
    padding-left: 50px;
}

.form {
    padding-left: 78px;
}

.title-box {
    margin: 20px 0;

    .title {
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 30px;
        position: relative;
        bottom: 5px;
    }
}

.chck {
    font-size: 14px;
    font-family: "Source Han Sans CN";
    font-weight: 400;
    color: #333333;
    line-height: 30px;
}

.el-col-offset-8 {
    margin-left: 40.3333%
}

.btn_fb {
    margin-top: 20px;
}

.image {
    width: 30%;
    height: 170px;
    margin-right: 3%;
}

.image:last-child {
    margin-right: 0;
}

.btn {
    width: 40%;
    height: 46px;
    border-radius: 8px;
    font-size: 18px;
    font-weight: 400;
}

.pass {
    margin-right: 51px;
}

.refuse {
    color: #1A80FC;
    background: #EEF2FB;
}

::v-deep .el-collapse {
    border: none;
}

.card_info {
    ::v-deep .el-form-item__content {
        padding-left: 2%;
    }

    ::v-deep .el-collapse-item__header {
        width: 80%;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        background-color: #EEF2FB;
        margin-left: -4px;
        padding: 0 1%;
        margin-bottom: 5px;

    }
}


.row-bg {
    margin-top: 20px;
}
</style>
